import ACTION_TYPES from '../../constants/actionTypes';
import api from '../../api';

/*
 * l10n
 * ========================================
 */

function getL10nRequest() {
  return {
    type: ACTION_TYPES.GET_L10N,
  };
}

function getL10nSuccess(data) {
  return {
    type: ACTION_TYPES.GET_L10N_SUCCESS,
    payload: data,
  };
}

function getL10nFailure(error) {
  return {
    type: ACTION_TYPES.GET_L10N_FAILURE,
    error,
  };
}

export function getL10n() {
  return (dispatch) => {
    dispatch(getL10nRequest());
    return new Promise((resolve, reject) => {
      api
        .getL10n()
        .then((response) => {
          dispatch(getL10nSuccess(response));
          resolve(response);
        })
        .catch((error) => {
          dispatch(getL10nFailure(error));
          reject(error);
        })
    });
  };
};
